<template>
  <div id="alarmPie"></div>
</template>
<script>
export default {
  props:['percent'],
  data() {
    return {
      myData: [
        { value: 12, name: "断电报警("+445+")次"},
        { value: 6, name: "超速报警("+445+")次" },
        { value: 8, name: "出围栏报警("+445+")次" },
        { value: 14, name: "离线报警("+445+")次" },
      ],
    };
  },
  methods: {
    drawBar(id) {
      var that = this;
      this.chart = this.echarts.init(document.getElementById(id), "dark");
      this.option = {
        backgroundColor: "",
        tooltip: {
          trigger: "item",
          // formatter: "{a} <br/>{b}: {c} ({d}%)"
          //formatter: "{b}: {c}辆 ({d}%)",
          formatter: "{b}: {d}%",
        },
        legend: {
          //图例组件
          left: 0, //图例组件离右边的距离
          //orient: "vertical", //布局  纵向布局
          width: 40, //图行例组件的宽度,默认自适应
          x: "right", //图例显示在右边
          itemWidth: 10, //图例标记的图形宽度
          itemHeight: 10, //图例标记的图形高度
          textStyle: {
            //图例文字的样式
            color: "#000",
            fontSize: 12,
          },
          //data: ["日常费用", "保养费", "维修费", "加油费"]
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["20%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            labelLine: {
              show: false,
            },
            data: this.myData,
          },
        ],
        color: [
          "#5e7aff",
          "#1cc3e7",
          "#ef3cf6",
          "#1bc85e",
          "#e8d611",
          "#ed982a",
          "#32e347",
          "#f25454",
        ],
        
      };

      this.chart.setOption(this.option);

      this.chart.resize();
    },
  },
  watch: {
    percent(v){
      console.log(v);
      this.myData=[];
      for (const i in v) {
        var obj={ value: v[i].num, name: v[i].typeName+"("+v[i].num+")次"};
        this.myData.push(obj);
      }
      setTimeout(() => {
      this.drawBar('alarmPie');
    }, 100);
    }
    
    
  },
};
</script>
<style lang="">
    #alarmPie{
        width: 100%;
        height: 100%;
    }
</style>


// WEBPACK FOOTER //
// ../common/src/components/alarm/pie.vue